(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    // ── Scroll reveal (soft fade-up) ───────────────────────────
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } });
        }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('pv-in');
    });

    // ── Clone the trust-pill row into the footer slot ──────────
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();

    // ── FAQ accordion (same behaviour as the product page) ─────
    document.querySelectorAll('[data-pv-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pv-faq-item');
        var open = item.classList.toggle('pv-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('.pv-faq-icon').textContent = open ? '−' : '+';
      });
    });

    // ── Contact form ───────────────────────────────────────────
    // PROTOTYPE ONLY: intercepts submit and shows a success message so the
    // page is demonstrable locally. On Shopify, use {% form 'contact' %}
    // (which posts for real) and REMOVE this handler.
    (function () {
      var form = document.getElementById('pv-cform');
      var success = document.getElementById('pv-cform-success');
      if (!form || !success) return;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var email = (document.getElementById('cf-email') || {}).value;
        if (email) {
          var p = document.getElementById('pv-cform-success-p');
          if (p) p.textContent = "We've received your message and we'll reply to " + email + " as soon as we can, usually within 24 hours.";
        }
        form.style.display = 'none';
        success.classList.add('pv-show');
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    })();

  });
})();
